import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOrder } from "../../context/OrderContext";
import api from "../../lib/api";
import { DoorOpen, AppWindow, ChevronRight } from "lucide-react";
import MeasureLaterNote from "../MeasureLaterNote";

export default function StepProduct() {
  const { state, update, goNext } = useOrder();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then((r) => { setProducts(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const windowProduct = products.find((p) => p.slug === "window-screen");
  const slidingTiers = products.filter((p) => p.type === "sliding_door" && p.tier);
  const hasSlidingTiers = slidingTiers.length > 0;
  const minSlidingPrice = hasSlidingTiers
    ? Math.min(...slidingTiers.map((p) => p.base_price))
    : null;
  const isWindowSelected = state.product?.slug === "window-screen";

  return (
    <div data-testid="step-product">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2 text-[var(--brand-text)]">
        What do you need today?
      </h1>
      <p className="muted-text mb-5">Pick a product to get started.</p>
      <MeasureLaterNote />

      {loading ? (
        <p className="muted-text">Loading products…</p>
      ) : (
        <div className="space-y-3">
          {windowProduct && (
            <button type="button" data-testid="product-card-window-screen"
              className={`option-card text-left w-full ${isWindowSelected ? "selected" : ""}`}
              onClick={() => update({ product: windowProduct })}>
              <div className="flex items-start gap-3">
                <div className="p-2 rounded-xl" style={{ background: "var(--brand-green-light)" }}>
                  <AppWindow className="w-7 h-7 brand-text" />
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-[var(--brand-text)]">{windowProduct.name}</p>
                  <p className="text-sm muted-text mt-0.5">{windowProduct.description}</p>
                  <p className="text-sm font-semibold mt-2 brand-text">
                    From ${windowProduct.base_price.toFixed(0)} each
                  </p>
                </div>
              </div>
            </button>
          )}
          {hasSlidingTiers && (
            <button type="button" data-testid="product-card-sliding-doors"
              className="option-card text-left w-full" onClick={() => navigate("/choose-your-door")}>
              <div className="flex items-start gap-3">
                <div className="p-2 rounded-xl" style={{ background: "var(--brand-green-light)" }}>
                  <DoorOpen className="w-7 h-7 brand-text" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <p className="font-semibold text-[var(--brand-text)]">Sliding Screen Doors</p>
                    <ChevronRight className="w-5 h-5 muted-text" />
                  </div>
                  <p className="text-sm muted-text mt-0.5">Choose from 3 tiers — Durango, Century, Premier.</p>
                  <p className="text-sm font-semibold mt-2 brand-text" data-testid="sliding-doors-from-price">
                    From ${minSlidingPrice.toFixed(0)} each
                  </p>
                </div>
              </div>
            </button>
          )}
        </div>
      )}

      <button data-testid="continue-btn" className="cta-btn mt-8"
        disabled={!isWindowSelected} onClick={goNext}>
        Continue
      </button>
    </div>
  );
}
